import React from 'react';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';

interface InputMaskProps extends MaskedInputProps {
  inputRef: (props: { value?: string; focus(): void }) => void;
}

// Component used to render text in text input components with masks
// for ref. check section Integration with 3rd party input libraries at
// https://v4.mui.com/components/text-fields/#integration-with-3rd-party-input-libraries
export function InputMask({ inputRef, ...maskedInputProps }: InputMaskProps) {
  return (
    <MaskedInput
      {...maskedInputProps}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      guide={false}
    />
  );
}
